import React, { Component } from 'react';
import {
  Badge,
  Row,
  Col,
  Card,
  CardHeader,
  CardBlock,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Input,
  InputGroup,
  InputGroupButton,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import ReactTable from 'react-table';
import 'react-table/react-table.css';



import { Link } from 'react-router-dom';

import Widget04 from '../Widgets/Widget04';

import * as Constant from '../../constants/AppConstants';
import axios from 'axios';

import update from 'immutability-helper';
import { loadProgressBar } from 'axios-progress-bar';

import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

$('body').on('click','.selectAllLeads',function(event){
  if($(this).prop('checked')){
    $('body').find('.selectLeads').prop('checked',true);
  }
  else {
    $('body').find('.selectLeads').prop('checked',false);
  }
});
 loadProgressBar()

class Dashboard extends Component {

  constructor(props) {
      super(props);
      this.state = {
        leadsData: [],
        drop: {},
        dashboardData: [],
        loading: true,
        average_disbursed_amount: '',
        total_disbursed_amount: '',
        limit:25,
        offset:0,
        query:'',
        lead_status:'',
        loan_status:'',
        applicationStatus:'',
        sort_col:'',
        sort:'',
        loggedOutModal: false,
        options: [],
        org_role: '',
        payback: 0,
      };
      this.getDashboard = this.getDashboard.bind(this);
      // this.nextpage = this.nextpage.bind(this);
      this.previouspage = this.previouspage.bind(this);
      this.handleUserInput = this.handleUserInput.bind(this);
      // this.addFilter = this.addFilter.bind(this);
      this.navigateToLogin = this.navigateToLogin.bind(this);
      this.logout = this.logout.bind(this);
      this.toggleLoggedOutModal = this.toggleLoggedOutModal.bind(this);
      this.verifyAuthToken = this.verifyAuthToken.bind(this);

  }
    componentDidMount() {
        this.sideNav();
        this.getAmountCount();
        this.getPosBifurcation();
    }

  verifyAuthToken(){
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
        mode:Constant.VERIFY_TOKEN_MODE,
        auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
        token: window.localStorage.getItem(Constant.TOKEN)
    })
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
        if(response.status == 200){
            self.getUserDetails();
        } else {
            self.logout();
        }
    })
    .catch(function (error) {
        self.logout();
    });
  }

  nextpage(){
        this.setState({
                offset:this.state.offset + this.state.limit
              },this.getLeads);

    }

     previouspage(){

       var offset = this.state.offset - this.state.limit;
       if(offset<0){
           offset = 0;
       }
        this.setState({
                offset:offset
              },this.getLeads);

    }

     addFilter(e){
        e.preventDefault();
        this.setState({
                offset : 0
              },this.getLeads);

    }

    // getLeads(){
    //   var self = this;
    //   var querystring = require('querystring');
    //   var payload = querystring.stringify({
    //       mode:Constant.GET_LEAD_MODE,
    //        "filters[query]":this.state.query,
    //        "filters[loan_status]":this.state.loan_status,
    //        "filters[lead_status]":this.state.lead_status,
    //        "filters[applicationStatus]":this.state.applicationStatus,
    //        sort:this.state.sort,
    //        sort_col:this.state.sort_col,

    //       limit :this.state.limit,
    //        offset:this.state.offset,
    //   }
    // )
    //   // console.log("Auth token: " + window.localStorage.getItem(Constant.AUTH_TOKEN));

    //   this.setState({
    //             loading:true
    //           });

    //     axios({
    //     method: 'post',
    //     url: Constant.API_URL,
    //     headers: {
    //         'content-type': 'application/x-www-form-urlencoded',
    //         'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
    //         'token': window.localStorage.getItem(Constant.TOKEN)
    //     },
    //     withCredentials: false,
    //     data: payload
    //   })
    //   .then(function (response) {
    //       if(response.status == 200){
    //           self.setState(prevState => ({
    //             leadsData: response.data.leads,
    //             // payback:response.data.payback,
    //             loading:false
    //           }));
    //       } else {

    //           self.setState(prevState => ({
    //             loading:false
    //           }));
    //       }
    //   })
    //   .catch(function (error) {
    //       self.setState(prevState => ({
    //             loading:false
    //           }));
    //   });
    // }


    getDashboard(){
      var self = this;
      var querystring = require('querystring');
      var payload = querystring.stringify({
          mode:Constant.GET_DASHBOARD_DATA,


      })
      // console.log("Auth token for dashboard: " + window.localStorage.getItem(Constant.AUTH_TOKEN));
        axios({
        method: 'post',
        url: Constant.API_URL,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
						'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
						'token': window.localStorage.getItem(Constant.TOKEN)
        },
        withCredentials: false,
        data: payload
      })
      .then(function (response) {
          if(response.status == 200){
              // console.log(response);
              var total_disbursed_amount = (response.data.reports.total_disbursed_amount);
              var average_disbursed_amount =  Math.round(response.data.reports.average_disbursed_amount);
              var options = (response.data.agents);
              var org_role = (response.data.user_details.org_role);
              self.setState(prevState => ({
                dashboardData: response.data.reports,
                options:options,
                org_role:org_role,
                total_disbursed_amount: total_disbursed_amount,
                average_disbursed_amount: average_disbursed_amount,
                loading: false
              }));
          }
          else if(response.data.error === "Invalid auth token"){
            self.toggleLoggedOutModal();
        }
        else if(response.data.error === "Login Expired"){
            self.toggleLoggedOutModal();
        }
          else {
              
          }
      })
      .catch(function (error) {

           self.setState(prevState => ({
                loading:false
              }));
      });
  }

  toggleLoggedOutModal(){
    this.setState({
      loggedOutModal: !this.state.loggedOutModal,
      mail_sent: false,
      mail_unable_to_send: false,
    })
  }

   navigateToLogin() {
    this.props.history.push('/login');
  }


  refreshPage(){
    window.location.reload()
  }

  handleUserInput(e){
     const name = e.target.name;
     const value = e.target.value;
     this.setState({[name] : value},function () {

    });

  }

   logout(){
    var self = this;
    var querystring = require('querystring');
    var payload = querystring.stringify({
        mode:Constant.MODE_LOGOUT
    })
    // console.log("Auth token: " + window.localStorage.getItem(Constant.AUTH_TOKEN));
    axios({
      method: 'post',
      // url: 'https://devapi.stasheasy.com/Admin/services/',
      url: 'https://api.stashfin.com/Admin/services',
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
        if(response.status == 200){

            window.localStorage.setItem(Constant.AUTH_TOKEN, "");
            window.localStorage.setItem(Constant.TOKEN, "");
            window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
            window.localStorage.setItem(Constant.ORG_ID, "");
            self.navigateToLogin();
        } else {

            window.localStorage.setItem(Constant.AUTH_TOKEN, "");
            window.localStorage.setItem(Constant.TOKEN, "");
            window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
            window.localStorage.setItem(Constant.ORG_ID, "");
            self.navigateToLogin();
        }
    })
    .catch(function (error) {

        window.localStorage.setItem(Constant.AUTH_TOKEN, "");
        window.localStorage.setItem(Constant.TOKEN, "");
        window.localStorage.setItem(Constant.IS_LOGGED_IN, false);
        window.localStorage.setItem(Constant.ORG_ID, "");
        self.navigateToLogin();
    });

  }


  getDisbursalReporting(event){
    var self = this;
    var querystring = require('querystring');
    if(event === 'sideNav'){
      var payload = querystring.stringify({
        mode:Constant.DISBURSAL_REPORTING 
      })
    }else if(event === 'btn') {
      var payload = querystring.stringify({
        mode        : Constant.DISBURSAL_REPORTING,
        start_date  : self.state.disbSetStartDate, 
        end_date    : self.state.disbSetEndDate,
        loan_status : self.state.LEADSTATUS,
        search      : self.state.searchBar, 
        utm_status  : self.state.DT_UTM_STATUS,
        limit       : this.state.limit,
        offset      : this.state.offset, 
      })   
    }else if(event === 'export'){
      var payload = querystring.stringify({
        mode        : Constant.DISBURSAL_REPORTING,
        start_date  : self.state.disbSetStartDate, 
        end_date    : self.state.disbSetEndDate,
        loan_status : self.state.LEADSTATUS,
        search      : self.state.searchBar,
        utm_status  : self.state.DT_UTM_STATUS,  
        download    : 'download',
      })
    }
    

    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
        if(response.status == 200){
          if(event === 'export'){
            var msg = response.data.data;
              const downloadUrl = msg.data;            
              console.log(downloadUrl);
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', 'file.pdf'); //any other extension
              document.body.appendChild(link);
              link.click();
              link.remove();
          }else{
            self.setState({
              DisbursalData : response.data.data,
            })
          }
            
        }
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }

  getPosReporting = (event) => {
    var self = this;
    var querystring = require('querystring');
    if(event === 'sideNav'){
      var payload = querystring.stringify({
        mode:Constant.POS_REPORTING, 
      })
    }else if(event === 'btn') {
      var payload = querystring.stringify({
        mode        : Constant.POS_REPORTING,
        dpdValue    : self.state.DPDvalue,
        start_date  : self.state.posSetStartDate,
        end_date    : self.state.posSetEndDate,
        utm_status  : self.state.POS_UTM_STATUS,
        limit       : this.state.limit,
        offset      : this.state.offset,
      })   
    }else if(event === 'export'){
      var payload = querystring.stringify({
        mode        : Constant.POS_REPORTING,
        dpdValue    : self.state.DPDvalue,
        start_date  : self.state.posSetStartDate,
        end_date    : self.state.posSetEndDate,
        utm_status  : self.state.POS_UTM_STATUS,
        download    : 'download', 
      })   
    }
    

    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {

        if(response.status == 200){
          if(event === 'export'){
              var msg = response.data.data;
              const downloadUrl = msg.data;            
              console.log(downloadUrl);
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', 'file.pdf'); //any other extension
              document.body.appendChild(link);
              link.click();
              link.remove();
          }else{
            self.setState({
              POSData : response.data.data,
            })
          }
        }
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }


  getPaymentHisDetails = (e) => {
    
    var self = this;
    var querystring = require('querystring');

      var payload = querystring.stringify({
        mode:Constant.POS_paymentHistory_Details,
        customer_id: this.state.cust_id,        
      })
      
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
        if(response.status == 200){
            self.setState({
              paymentDetails  : response.data.data,
            })
        }
        // console.log(self.state.inst_status);
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }

  getPaymentHisTab = (e) => {
    var self = this;
    var querystring = require('querystring');
    
    if(e === 'export' ){
      var payload = querystring.stringify({
        mode:Constant.PAYMENT_HIS_DETAILS ,
        start_date  : self.state.recvSetStartDate, 
        end_date    : self.state.recvSetEndDate,
        status      : self.state.PaymentLeadStatus,
        utm_status  : self.state.PRT_UTM_STATUS,
        download    : 'download',        
      })
    }else{
      var payload = querystring.stringify({
        mode:Constant.PAYMENT_HIS_DETAILS ,
        start_date  : self.state.recvSetStartDate, 
        end_date    : self.state.recvSetEndDate,
        status      : self.state.PaymentLeadStatus,
        utm_status  : self.state.PRT_UTM_STATUS,
        limit       : this.state.limit,
        offset      : this.state.offset,        
      })
    }
      
      
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
        if(response.status == 200){
              if(e === 'export' ){
                var msg = response.data.data;
                const downloadUrl = msg.data;            
                console.log(downloadUrl);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'file.pdf'); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                }else{
                  self.setState({
                    paymentRecDetails  : response.data.data,
                  })
                }

        }

    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }

  // getPOSPaymentHisTab = (e) => {
    getPOSPaymentHisTab = (event) => {
      var self = this;
      var querystring = require('querystring');
      if(event === 'sideNav'){
        var payload = querystring.stringify({
          mode:Constant.AKARA_POS_DATA, 
        })
      }else if(event === 'btn') {
        var payload = querystring.stringify({
          mode        : Constant.AKARA_POS_DATA,
          dpdValue    : self.state.DPDvalue,
          start_date  : self.state.posSetStartDate,
          end_date    : self.state.posSetEndDate,
          utm_status  : self.state.POS_UTM_STATUS,
          limit       : this.state.limit,
          offset      : this.state.offset,
        })   
      }else if(event === 'export'){
        var payload = querystring.stringify({
          mode        : Constant.AKARA_POS_DATA,
          dpdValue    : self.state.DPDvalue,
          start_date  : self.state.posSetStartDate,
          end_date    : self.state.posSetEndDate,
          utm_status  : self.state.POS_UTM_STATUS,
          download    : 'download', 
        })   
      }
      
  
      axios({
        method: 'post',
        url: Constant.API_URL,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
            'token': window.localStorage.getItem(Constant.TOKEN)
        },
        withCredentials: false,
        data: payload
      })
      .then(function (response) {
  
          if(response.status == 200){
            if(event === 'export'){
                var msg = response.data.data;
                const downloadUrl = msg.data;            
                console.log(downloadUrl);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'file.pdf'); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
            }else{
              self.setState({
                akaraPOSData : response.data.data,
              })
            }
          }
      })
      .catch(function (error) {
          // self.navigateToLogin();
      });
  
    }
  

  getPaymentChildTab(payment_id ){
    var self = this;
    var querystring = require('querystring');
      var payload = querystring.stringify({
        mode:Constant.INST_DETAILS ,
        payment_id : payment_id,
      })
      
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
      if(response.status == 200){
            self.setState({
              instDetails  : response.data.data,
            })
        }
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }


  getDetailsTab(event ){
    var self = this;
    var querystring = require('querystring');
      var payload = querystring.stringify({
        mode:Constant.DETAILS_PAGE,
        loan_id : this.state.selectLoanId,
      })
      
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {

      if(response.status == 200){
            self.setState({
              detailsPage  : response.data.data,
            })
        }
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }

  getAkaraDetailsTab(event ){
    var self = this;
    var querystring = require('querystring');
      var payload = querystring.stringify({
        mode:Constant.AKARA_DETAILS_PAGE,
        loan_id : this.state.selectLoanId,
      })
      
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {

      if(response.status == 200){
            self.setState({
              AkaradetailsPage  : response.data.data,
            })
        }
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }
  
  getinstColender(inst_id ){
    var self = this;
    var querystring = require('querystring');
      var payload = querystring.stringify({
        mode    :Constant.INST_COLENDER,
        inst    :inst_id,
        loan_id : this.state.selectLoanId,
      })
      
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
      if(response.status == 200){
            self.setState({
              instColender  : response.data.data,
            })
        }
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }

  getApplicantDetails(event){
    var self = this;
    var querystring = require('querystring');
      var payload = querystring.stringify({
        mode:Constant.APPLICANT_DETAILS,
        loan_id : this.state.selectLoanId,
      })
      
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
      if(response.status == 200){
            self.setState({
              applicantDetails  : response.data.data,
              cust_id           : response.data.data.cust_id,
              letsMd_id         : response.data.data.letsMd_id,
              st_loan_id        : response.data.data.st_loan_id,
              customer_name     : response.data.data.customer_name,
              approved_amount   : response.data.data.approved_amount,
              approved_rate     : response.data.data.approved_rate,
              approved_tenure   : response.data.data.approved_tenure,
              first_date        : response.data.data.first_date,
              last_date         : response.data.data.last_date,
              app_principle_due : response.data.data.principle_due,
              product_code      : response.data.data.product_code,
              MaxDPD            : response.data.data.dpd,
            })
        }
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }
 
  getAmountCount(){
    var self = this;
    var querystring = require('querystring');
      var payload = querystring.stringify({
        mode         :Constant.AMOUNT_COUNT,
        utm_status   :self.state.UTM_STATUS,
      })
      
    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
      if(response.status == 200){
            self.setState({
              count_dusb        : response.data.data.disb.disb_count,
              disb_amount       : response.data.data.disb.disb_amount,
              collected_count   : response.data.data.collected.collected_count,
              collected_amount  : response.data.data.collected.collected_amount,
            })
        }
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }

  getPosBifurcation(){
    var self = this;
    var querystring = require('querystring');
      var payload   = querystring.stringify({
        mode        :Constant.POS_BIFURCATION,
        utm_status  : self.state.UTM_STATUS,
      })

    axios({
      method: 'post',
      url: Constant.API_URL,
      headers: {
          'content-type': 'application/x-www-form-urlencoded',
					'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
					'token': window.localStorage.getItem(Constant.TOKEN)
      },
      withCredentials: false,
      data: payload
    })
    .then(function (response) {
      if(response.status == 200){console.log(response.data.data.level0);
            self.setState({
              level0POS : response.data.data.level0.POS,
              level0ID  : response.data.data.level0.interest_due,
              level0PeD : response.data.data.level0.penalty_due,
              level0PD  : response.data.data.level0.principle_due,
              level0TO  : response.data.data.level0.total_overdue,
              level1POS : response.data.data.level1.POS,
              level1ID  : response.data.data.level1.interest_due,
              level1PeD : response.data.data.level1.penalty_due,
              level1PD  : response.data.data.level1.principle_due,
              level1TO  : response.data.data.level1.total_overdue,
              level2POS : response.data.data.level2.POS,
              level2ID  : response.data.data.level2.interest_due,
              level2PeD : response.data.data.level2.penalty_due,
              level2PD  : response.data.data.level2.principle_due,
              level2TO  : response.data.data.level2.total_overdue,
              level3POS : response.data.data.level3.POS,
              level3ID  : response.data.data.level3.interest_due,
              level3PeD : response.data.data.level3.penalty_due,
              level3PD  : response.data.data.level3.principle_due,
              level3TO  : response.data.data.level3.total_overdue,
              level4POS : response.data.data.level4.POS,
              level4ID  : response.data.data.level4.interest_due,
              level4PeD : response.data.data.level4.penalty_due,
              level4PD  : response.data.data.level4.principle_due,
              level4TO  : response.data.data.level4.total_overdue,
            })
          }
          self.getAmountCount();
    })
    .catch(function (error) {
        // self.navigateToLogin();
    });

  }



// ============================================================{ set_values }===========================================================

      handleChange(field, e) {
      
        this.setState({
            dsaData: []
        });

        var d = new Date();


        let temp_dsaFields = this.state.dsaFields;
        temp_dsaFields[field] = e.target.value;

        this.setState({

            dsaFields: temp_dsaFields
        });

        if (this.state.dsaFields["month"].split('-')[0] < 2017 || this.state.dsaFields["month"].split('-')[0] > d.getFullYear()) {
            this.setState({
                errmsg: 'Enter a year between 2017 and ' + d.getFullYear()
            });

        }

        else if (this.state.dsaFields["dsa"] == "0" || this.state.dsaFields["dsa"] == "" || this.state.dsaFields["dsa"] == null) {


            this.setState({
                errmsg: "Please select a valid DSA Partner"
            });
        }
        else if (this.state.dsaFields["month"] == "0" || this.state.dsaFields["month"] == "" || this.state.dsaFields["month"] == null) {


            this.setState({
                errmsg: "Please select a valid month/year"
            });
        }

        else { this.handleOptionChange(); }

      }

    set_UTM_STATUS = (e) =>{
      this.setState({ UTM_STATUS : e.target.value,}, () => { this.temp(); })
    }

    set_DT_UTM_STATUS = (e) =>{
      this.setState({ DT_UTM_STATUS : e.target.value,}, () => { this.temp(); })
    }

    set_POS_UTM_STATUS = (e) =>{
      this.setState({ POS_UTM_STATUS : e.target.value,}, () => { this.temp(); })
    }

    set_PRT_UTM_STATUS = (e) =>{
      this.setState({ PRT_UTM_STATUS : e.target.value,}, () => { this.temp(); })
    }



  disbSetStartDate = (e) => {
    this.setState({ disbSetStartDate : e.target.value,},() => { this.temp(); })
    this.check();
  }
  
  disbSetEndDate = (e) => {
    this.setState({ disbSetEndDate : e.target.value,},() => { this.temp(); })
    this.check();
  }

  check= (e) => {
    this.check();

      this.state.disbSetStartDate();
      this.state.disbSetEndDate();

  }


  posSetStartDate = (e) => {
    this.setState({   posSetStartDate : e.target.value,},() => { this.temp(); })
  }

  posSetEndDate = (e) => {
    this.setState({ posSetEndDate : e.target.value,},() => { this.temp(); })
  }
  

  recvSetStartDate = (e) => {
    this.setState({   recvSetStartDate : e.target.value,},() => { this.temp(); })
  }
  
  recvSetEndDate = (e) => {
    this.setState({   recvSetEndDate : e.target.value,},() => { this.temp(); })
  }
  
  setSearch = (e) => {
    this.setState({ searchBar : e.target.value,},() => { this.temp(); })
  }

  setDpdVal = (e) =>{
    this.setState({ DPDvalue : e.target.value,},() => { this.temp(); })
  } 
  PaymentLeadStatus = (e) =>{
    this.setState({ PaymentLeadStatus : e.target.value,},() => { this.temp(); })
  } 

  setLeadStatus = (e) => {
    this.setState({ LEADSTATUS : e.target.value,},() => { this.temp(); })
  }
  // selection of name 
  home_func = (e) => { 
    this.setState({ selectNav : 'HOME'}, () => { this.sideNav(); this.getPosBifurcation(); this.getAmountCount(); }) 
  }
  disbursed_func = (e) => { 
    this.setState({ selectNav : 'DISBURSAL_REOPRT'}, () => { this.sideNav();  this.getDisbursalReporting(event='sideNav'); })
  }
  pos_data_func = (e) => { 
    this.setState({ selectNav : 'POS_DATA' ,dDetail : 'POS_DATA' }, () => { this.sideNav(); this.getPosReporting(event='sideNav'); }) 
  }
  wise_details_func = (e) => {
    this.setState({ selectNav : 'WISE_DETAIL' , selectLoanId:e,}, () => { this.sideNav(); this.getApplicantDetails(e);}) 
  }
  
  payment_rec_func = (e) => { 
    this.setState({ selectNav : 'PAYMENT_RECEIVED'}, () => { this.sideNav(); this.getPaymentHisTab(event='sideNav'); }) 
  }

  pos_akara_func = (e) => { 
    this.setState({ selectNav : 'POS_AKARA' ,dDetail : 'POS_AKARA' }, () => { this.sideNav(); this.getPOSPaymentHisTab(event='sideNav'); }) 
    // this.setState({ selectNav : 'POS_AKARA'}, () => { this.sideNav(); this.pos_akara_func(event='sideNav'); }) 
  }

  temp = (e) => {   
  console.log('N/A');
  console.log('N/A');
  console.log('N/A');
  console.log('N/A');
  }



//  btnExport =  () =>{
//     var dt = new Date();
//     var day = dt.getDate();
//     var month = dt.getMonth() + 1;
//     var year = dt.getFullYear();
//     var hour = dt.getHours();
//     var mins = dt.getMinutes();
//     var postfix = day + "." + month + "." + year + "_" + hour + "." + mins;
//     //creating a temporary HTML link element (they support setting file names)
//     var a = document.createElement('a');
//     //getting data from our div that contains the HTML table
//     var data_type = 'data:application/vnd.ms-excel';
//     var table_div = document.getElementById('dvData');
//     var table_html = table_div.outerHTML.replace(/ /g, '%20');
//     a.href = data_type + ', ' + table_html;
//     //setting the file name
//     a.download = 'exported_table_' + postfix + '.xls';
//     //triggering the function
//     a.click();
//     //just in case, prevent default behaviour
//     e.preventDefault();
//  }
  
// ======================================================{ end }==================================================



  // display tabs while we select sidenave
  sideNav = () => {
    var selected = this.state.selectNav;

    if(selected === 'HOME'){
      
      this.refs.home.setAttribute("style","display:block;");
      this.refs.disbursal_report.setAttribute("style","display:none;");
      this.refs.POS_data.setAttribute("style","display:none;");
      this.refs.wise_detail.setAttribute("style","display:none;");
      this.refs.payment_received.setAttribute("style","display:none;");
      this.refs.POS_Akara_data.setAttribute("style","display:none;");

    }else if(selected === 'DISBURSAL_REOPRT'){
      
      this.refs.home.setAttribute("style","display:none;");
      this.refs.disbursal_report.setAttribute("style","display:block;");
      this.refs.POS_data.setAttribute("style","display:none;");
      this.refs.wise_detail.setAttribute("style","display:none;");
      this.refs.payment_received.setAttribute("style","display:none;");
      this.refs.POS_Akara_data.setAttribute("style","display:none;");

    }else if(selected === 'POS_DATA'){
      
      this.refs.home.setAttribute("style","display:none;");
      this.refs.disbursal_report.setAttribute("style","display:none;");
      this.refs.POS_data.setAttribute("style","display:block;");
      this.refs.wise_detail.setAttribute("style","display:none;");
      this.refs.payment_received.setAttribute("style","display:none;");
      this.refs.POS_Akara_data.setAttribute("style","display:none;");

    }else if(selected === 'WISE_DETAIL'){
      
      this.refs.home.setAttribute("style","display:none;");
      this.refs.disbursal_report.setAttribute("style","display:none;");
      this.refs.POS_data.setAttribute("style","display:none;");
      this.refs.wise_detail.setAttribute("style","display:block;");
      this.refs.payment_received.setAttribute("style","display:none;");
      this.refs.POS_Akara_data.setAttribute("style","display:none;");

    }else if(selected === 'PAYMENT_RECEIVED'){
    
      this.refs.home.setAttribute("style","display:none;");
      this.refs.disbursal_report.setAttribute("style","display:none;");
      this.refs.POS_data.setAttribute("style","display:none;");
      this.refs.wise_detail.setAttribute("style","display:none;");
      this.refs.payment_received.setAttribute("style","display:block;");
      this.refs.POS_Akara_data.setAttribute("style","display:none;");

    }else if(selected === 'POS_AKARA'){
    
      this.refs.home.setAttribute("style","display:none;");
      this.refs.disbursal_report.setAttribute("style","display:none;");
      this.refs.POS_data.setAttribute("style","display:none;");
      this.refs.wise_detail.setAttribute("style","display:none;");
      this.refs.payment_received.setAttribute("style","display:none;");
      this.refs.POS_Akara_data.setAttribute("style","display:block;");

    }else{
      this.refs.home.setAttribute("style","display:block;");
    }

  }



  wiseTabs_func = (e) =>{
    var tabSelect = e.target.name; 

    if(tabSelect === 'applicant_details'){
    
      this.refs.applicant_details .setAttribute("style","display:block;");
      this.refs.payment_history   .setAttribute("style","display:none;");
      this.refs.details           .setAttribute("style","display:none;");
      this.refs.akara_details     .setAttribute("style","display:none;");
    
    }else if(tabSelect === 'payment_history'){
    
      this.getPaymentHisDetails();
      this.refs.applicant_details .setAttribute("style","display:none;");
      this.refs.payment_history   .setAttribute("style","display:block;");
      this.refs.details           .setAttribute("style","display:none;");
      this.refs.akara_details     .setAttribute("style","display:none;");
      
    
    }else if(tabSelect === 'details'){
    
      this.refs.applicant_details .setAttribute("style","display:none;");
      this.refs.payment_history   .setAttribute("style","display:none;");
      
      if(this.state.dDetail === 'POS_AKARA'){
        this.getAkaraDetailsTab();
        this.refs.akara_details .setAttribute("style","display:block;");
        this.refs.details       .setAttribute("style","display:none;");
      }else if(this.state.dDetail === 'POS_DATA'){
        this.getDetailsTab();
        this.refs.akara_details .setAttribute("style","display:none;");
        this.refs.details       .setAttribute("style","display:block;");
      }
     
    }
  }
  onClickOutside = (e) => {
    this.setState({ expanded: false });
  }

  prevPage = (e) => {
    var offset = this.state.offset - 25;
    if (offset < 0) {
        offset = 0;
    }
    this.setState({
        offset: offset
    }, () => {
        if(e === 'Payment_Received'){
          this.getPaymentHisTab();
        }else if (e === 'Disbursal_Report'){
          this.getDisbursalReporting(event='btn');
        }else if(e ==='POS_Report' ){
          this.getPosReporting(event='btn');
        }

      });
    console.log(e);


  }

  nxtpage = (e) => {
    this.setState({
        offset: this.state.offset + 25
    }, () => {
        if(e === 'Payment_Received'){
          this.getPaymentHisTab();
        }else if(e === 'Disbursal_Report'){
          this.getDisbursalReporting(event='btn'); 
        }else if(e ==='POS_Report' ){
          this.getPosReporting(event='btn');
        }
    });


  }
 
  render() {

    return (
    <div>

{/*  =========================================================================== sidebar tab =================================================================== */}

<SideNav
        expanded={this.state.expanded}
        onToggle={(expanded) => {
            this.setState({ expanded });
        }}
    >

    <SideNav.Toggle />
    <SideNav.Nav defaultSelected="home">
    
        <NavItem  onClick={(e) => this.home_func(e)} >
            <NavIcon>
                <i className="fa fa-fw fa-home" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText >
                  Home
            </NavText>
        </NavItem>

        <NavItem  onClick={(e) => this.disbursed_func(e)}>
        <NavIcon>
                <i className="fa fa-line-chart" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
                  Disbursal Report 
            </NavText>
        </NavItem>
        <NavItem  onClick={(e) => this.pos_data_func(e)}>
            <NavIcon>
                <i className="fa fa-credit-card" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
                  POS Data
            </NavText>
        </NavItem>
        {/* <NavItem  onClick={(e) => this.wise_details_func(e)}>
            <NavIcon>
                <i className="fa fa-money" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
                  Loan ID Wise Detail in POS
            </NavText>
        </NavItem> */}
        <NavItem  onClick={(e) => this.payment_rec_func(e)}>
            <NavIcon>
                <i className="fa fa-inr" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
                  Payment Received
            </NavText>
        </NavItem>

        {/* <NavItem eventKey="charts">
            <NavIcon>
                <i className="fa fa-fw fa-line-chart" style={{ fontSize: '1.75em' }} />
            </NavIcon>
            <NavText>
                Disbursal Report 
            </NavText>
        </NavItem> */}
        
    </SideNav.Nav>
</SideNav>


{/*  =========================================================================== END sidebar =================================================================== */}

      <Card className='partner-card' onClick={(e) => this.onClickOutside()} >
        <CardHeader>
{/*  =========================================================================== home tab =================================================================== */}
        <div ref='home' style={{display : 'none'}} >
              <Row>
                <Col md="2.1" className="report-bx">
                <Widget04 icon="icon-people" color="info" header={this.state.count_dusb ? this.state.count_dusb : '0'} invert>MTD Disbursal Count</Widget04>
                </Col>
                <Col md="2.1" className="report-bx">
                <Widget04 icon="icon-check" color="success" header={this.state.disb_amount ? this.state.disb_amount : '0'} invert>MTD Disbursal Amount</Widget04>
                </Col>
                <Col md="2.1" className="report-bx">
                <Widget04 icon="icon-user-follow" color="primary" header={this.state.collected_count ? this.state.collected_count : '0'} invert>MTD Collection Count</Widget04>
                </Col>
                <Col md="2.1" className="report-bx">
                <Widget04 icon="icon-ban" color="danger" header={this.state.collected_amount ? this.state.collected_amount : '0'} invert>MTD Collection Amount</Widget04>
                </Col>
            </Row>
            {/* <div className="card">
              <div className="card-header">
              <select name="lead_status" id="select"  className="deepsearchselect" value={this.state.LetsMD} onChange={(event)=> this.set_UTM_STATUS(event)}>
                  <option  value="">UTM Source</option>
                  <option  value="ALL">ALL</option>
                  <option  value="LetsMD">LetsMD</option>
                  <option  value="LoanSimple">LoanSImple</option>
                  <option  value="Rupeelend">Rupeelend</option>
                </select>&nbsp;&nbsp;
                <div type="button" className="btn btn-primary btn-sm" name = 'homeTab' onClick={(e) => this.getPosBifurcation(e = 'homeTab')} > Search</div>
              </div>
            </div> */}

            <div>
                  <div style={{background: '#2196f3' }} className="col-sm-2" >&nbsp;&nbsp;</div>
                  <div style={{background: '#2196f3' }} className="col-sm-2" >&nbsp;&nbsp;</div>
                  <div style={{background: '#2196f3' }} className="col-sm-1" >&nbsp;&nbsp;</div>
                  <div style={{background: '#2196f3', color: 'white'}} className="col-sm-2" ><u>POS Classification</u></div>
                  <div style={{background: '#2196f3' }} className="col-sm-2" >&nbsp;&nbsp;</div>
                  <div style={{background: '#2196f3' }} className="col-sm-2" >&nbsp;&nbsp;</div>
                  <div style={{background: '#2196f3' }} className="col-sm-1" >&nbsp;&nbsp;</div>
            </div>
            <div>
                  <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >DPD</div>
                  <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >POS</div>
                  <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Total Overdue Amount</div>
                  <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Principal Overdue</div>
                  <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Interest Overdue</div>
                  <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Penalty</div>
            </div>

            <div>
                  <div className="col-sm-2" >00 DPD</div>
                  <div className="col-sm-2" >{this.state.level0POS ? this.state.level0POS : '-' }</div>
                  <div className="col-sm-2" >{this.state.level0TO  ? this.state.level0TO : '-' }</div>
                  <div className="col-sm-2" >{this.state.level0PD  ? this.state.level0PD : '-' }</div>
                  <div className="col-sm-2" >{this.state.level0ID  ? this.state.level0ID : '-' }</div>
                  <div className="col-sm-2" >{this.state.level0PeD ? this.state.level0PeD : '-' }</div>
            </div>            
            <div>
                  <div className="col-sm-2" >01-30 DPD</div>
                  <div className="col-sm-2" >{this.state.level1POS ? this.state.level1POS : '-' }</div>
                  <div className="col-sm-2" >{this.state.level1TO ? this.state.level1TO : '-' }</div>
                  <div className="col-sm-2" >{this.state.level1PD ? this.state.level1PD : '-' }</div>
                  <div className="col-sm-2" >{this.state.level1ID ? this.state.level1ID : '-' }</div>
                  <div className="col-sm-2" >{this.state.level1PeD ? this.state.level1PeD : '-' }</div>
            </div>
            
            <div>
                  <div className="col-sm-2" >31-60 DPD</div>
                  <div className="col-sm-2" >{this.state.level2POS ? this.state.level2POS : '-'}</div>
                  <div className="col-sm-2" >{this.state.level2TO ? this.state.level2TO : '-'}</div>
                  <div className="col-sm-2" >{this.state.level2PD ? this.state.level2PD : '-'}</div>
                  <div className="col-sm-2" >{this.state.level2ID ? this.state.level2ID : '-'}</div>
                  <div className="col-sm-2" >{this.state.level2PeD ? this.state.level2PeD : '-'}</div>
            </div>
            <div>
                  <div className="col-sm-2" >60-90 DPD</div>
                  <div className="col-sm-2" >{this.state.level3POS ? this.state.level3POS : '-'}</div>
                  <div className="col-sm-2" >{this.state.level3TO ? this.state.level3TO : '-'}</div>
                  <div className="col-sm-2" >{this.state.level3PD ? this.state.level3PD : '-'}</div>
                  <div className="col-sm-2" >{this.state.level3ID ? this.state.level3ID : '-'}</div>
                  <div className="col-sm-2" >{this.state.level3PeD ? this.state.level3PeD : '-'}</div>
            </div>
            <div>
                  <div className="col-sm-2" >90 + DPD</div>
                  <div className="col-sm-2" >{this.state.level4POS ? this.state.level4POS : '-'}</div>
                  <div className="col-sm-2" >{this.state.level4TO ? this.state.level4TO : '-'}</div>
                  <div className="col-sm-2" >{this.state.level4PD ? this.state.level4PD : '-'}</div>
                  <div className="col-sm-2" >{this.state.level4ID ? this.state.level4ID : '-'}</div>
                  <div className="col-sm-2" >{this.state.level4PeD ? this.state.level4PeD : '-'}</div>
            </div>

        </div>
{/*  =========================================================================== disbursal tab =================================================================== */}
        <div ref='disbursal_report' style={{display : 'none'}} >
        
        <div className="card">
            <div className="card-header">
                  From Date<input type="date" onChange={(event)=> this.disbSetStartDate(event)} />
                      &nbsp;&nbsp;
                  To Date<input type="date"  onChange={(event)=> this.disbSetEndDate(event)} />
                      &nbsp;&nbsp;
                  <input type='text' placeholder='Search By Loan Id / Name' onChange={(event)=> this.setSearch(event)} />
                      &nbsp;&nbsp;
                  <select name="lead_status" id="leadselect" className="deepsearchselect"  onChange={(event)=> this.setLeadStatus(event)}>
                    <option value="">Lead Status</option>
                    <option value="5">Disbursed</option>
                    <option value="4">Rejected</option>
                    <option value="17">Cancelled</option>
                  </select>
                      &nbsp;&nbsp;
                  {/* <select name="utm_status" id="select"  className="deepsearchselect"  onChange={(event)=> this.set_DT_UTM_STATUS(event)}>
                    <option value="">UTM Source</option>
                    <option value="ALL">ALL</option>
                    <option value="LetsMD">LetsMD</option>
                    <option value="LoanSimple">LoanSImple</option>
                    <option value="Rupeelend">Rupeelend</option>
                  </select>&nbsp;&nbsp; */}
                  <button  className="btn btn-primary btn-sm" onClick={(event)=> this.getDisbursalReporting(event='btn')} >search</button>
                      &nbsp;&nbsp;
                  <div  className="btn btn-primary btn-sm" onClick={(event)=> this.getDisbursalReporting(event='export')} >Export</div>
            </div>
        </div>

          
        <h5>Disbursal Report</h5>
          <ReactTable data={this.state.DisbursalData} 
                  columns={[
                          { Header: 'Disbursed Date',       accessor: 'disbursal_date'},
                          { Header: 'Partners ID',          accessor: 'EXT_Ref_ID' },
                          { Header: 'StashFin Loan ID',     accessor: 'LID' },  
                          { Header: 'StashFin Customer Id', accessor: 'CID' }, 
                          { Header: 'Customer Name',        accessor: 'Cust name' },
                          { Header: 'Approve Amt',          accessor: 'Approved Amount' },
                          { Header: 'Net Disbursed Amount', accessor: 'Bank Disbursal Amt' },
                          { Header: 'EMI Amt',              accessor: 'EMI chq amount' },
                          // { Header: 'Loan Status', accessor: 'status_type' },
                    ]} 
                defaultSorted={[{id:'disbursal_date',desc:true}]} 
                defaultPageSize={20}
                className="-striped -highlight"
                showPagination={false}
            />
              <div type="button" className="btn btn-primary btn-sm-5" style={{float:'left'}}  onClick={(e) => this.prevPage(e='Disbursal_Report')}> Previous </div>
              <div type="button" className="btn btn-primary btn-sm-5" style={{float:'right'}} onClick={(e) => this.nxtpage(e='Disbursal_Report')}> Next </div>


        </div>
{/*  =========================================================================== POS DATA tab =================================================================== */}
        <div ref='POS_data' style={{display : 'none'}} >
        <div className="card">
              <div className="card-header">
                  {/* From Date<input type="date" onChange={(event)=> this.posSetStartDate(event)} />
                    &nbsp;&nbsp;
                  To Date<input type="date" onChange={(event)=> this.posSetEndDate(event)} />
                    &nbsp;&nbsp; */}
                      <select name="lead_status" id="select" className="deepsearchselect" value={this.state.DPDvalue} onChange={(event)=> this.setDpdVal(event)}>
                        <option value="">DPD Status</option>
                        <option value="">All</option>
                        <option value="00">00 DPD</option>
                        <option value="1-30">1-30 DPD</option>
                        <option value="31-60">31-60 DPD</option>
                        <option value="60-90">60-90 DPD </option>
                        <option value="90">90+ DPD </option>
                      </select>
                  &nbsp;&nbsp;
                    {/* <select name="lead_status" id="select"  className="deepsearchselect" value={this.state.LetsMD} onChange={(event)=> this.set_POS_UTM_STATUS(event)}>
                      <option value="">UTM Source</option>
                      <option value="ALL">ALL</option>
                      <option value="LetsMD">LetsMD</option>
                      <option value="LoanSimple">LoanSImple</option>
                      <option value="Rupeelend">Rupeelend</option>
                    </select>&nbsp;&nbsp; */}
                  <button  className="btn btn-primary btn-sm" onClick={(event)=> this.getPosReporting(event='btn')} >search</button> 
                  &nbsp;&nbsp;
                  <div  className="btn btn-primary btn-sm" onClick={(event)=> this.getPosReporting(event='export')} >Export</div> 
                  &nbsp;&nbsp;
                  <div  className="btn btn-primary btn-sm" onClick={(e)=> this.pos_akara_func(e)} >Akara Details</div> 
              </div>
          </div>

          <h5>POS Report</h5>
              <ReactTable data={this.state.POSData} 
                        columns={[
                            { Header: "Disbursed Date",accessor: "disbursal_date" ,width:125},
                            { Header: 'Partners ID', accessor: 'EXT_Ref_ID' ,width:100},
                            { Header: 'StashFin LID', id:'LID', accessor: d => d.LID ,width:'100', Cell: row => (<span style={{color: 'blue'}}  onClick={(e) => this.wise_details_func(row.value)} >{row.value}</span>),width:100 }, 
                            { Header: 'StashFin CID', accessor: 'CID' ,width:100}, 
                            { Header: 'Customer Name', accessor: 'cust_name' ,width:130},
                            { Header: 'Approve Amt', accessor: 'approved_amount' ,width:100},
                            { Header: 'Tenure', accessor: 'approved_tenure' ,width:100},
                            { Header: 'DPD Status', accessor: 'dpd' ,width:100},
                            { Header: 'POS', accessor: 'principal_outstanding' ,width:100},
                            { Header: 'Overdue Principal', accessor: 'principle_due',width:130},      
                            { Header: 'Overdue Interest', accessor: 'interest_due',width:130},
                            { Header: 'Penality', accessor: 'charges_due' ,width:100},
                            { Header: 'Total Overdue Amt', accessor: 'total_overdue' ,width:140}
                      ]} 
                  defaultSorted={[{id:'disbursal_date',desc:true}]} 
                  defaultPageSize={20}
                  className="-striped -highlight"
                  showPagination={false}
              />
              <div type="button" className="btn btn-primary btn-sm-5" style={{float:'left'}}  onClick={(e) => this.prevPage(e='POS_Report')}> Previous </div>
              <div type="button" className="btn btn-primary btn-sm-5" style={{float:'right'}} onClick={(e) => this.nxtpage(e='POS_Report')}> Next </div>
              
        </div>


        <div ref='POS_Akara_data' style={{display : 'none'}} >
        <div className="card">
              <div className="card-header">
                  {/* From Date<input type="date" onChange={(event)=> this.posSetStartDate(event)} />
                    &nbsp;&nbsp;
                  To Date<input type="date" onChange={(event)=> this.posSetEndDate(event)} />
                    &nbsp;&nbsp; */}
                      <select name="lead_status" id="select" className="deepsearchselect" value={this.state.DPDvalue} onChange={(event)=> this.setDpdVal(event)}>
                        <option value="">DPD Status</option>
                        <option value="">All</option>
                        <option value="00">00 DPD</option>
                        <option value="1-30">1-30 DPD</option>
                        <option value="31-60">31-60 DPD</option>
                        <option value="60-90">60-90 DPD </option>
                        <option value="90">90+ DPD </option>
                      </select>
                  &nbsp;&nbsp;
                    {/* <select name="lead_status" id="select"  className="deepsearchselect" value={this.state.LetsMD} onChange={(event)=> this.set_POS_UTM_STATUS(event)}>
                      <option value="">UTM Source</option>
                      <option value="ALL">ALL</option>
                      <option value="LetsMD">LetsMD</option>
                      <option value="LoanSimple">LoanSImple</option>
                      <option value="Rupeelend">Rupeelend</option>
                    </select>&nbsp;&nbsp; */}
                  <button  className="btn btn-primary btn-sm" onClick={(event)=> this.getPOSPaymentHisTab(event='btn')} >search</button> 
                  &nbsp;&nbsp;
                  <div  className="btn btn-primary btn-sm" onClick={(event)=> this.getPOSPaymentHisTab(event='export')} >Export</div> 
                  &nbsp;&nbsp;
                  <div  className="btn btn-primary btn-sm" onClick={(e) => this.pos_data_func(e)} >POS Details</div> 
              </div>
          </div>

          <h5>POS Akara Report</h5>
              <ReactTable data={this.state.akaraPOSData} 
                        columns={[
                            { Header: "Disbursed Date",     accessor: "disbursal_date" ,width:125},
                            { Header: 'Partners ID',          accessor: 'EXT_Ref_ID' ,width:100},
                            { Header: 'StashFin LID', id:'LID', accessor: d => d.LID ,width:'100', Cell: row => (<span style={{color: 'blue'}}  onClick={(e) => this.wise_details_func(row.value)} >{row.value}</span>),width:100 }, 
                            { Header: 'StashFin CID',       accessor: 'CID' ,width:100}, 
                            { Header: 'Customer Name',      accessor: 'cust_name' ,width:130},
                            { Header: 'Approve Amt',        accessor: 'approved_amount' ,width:100},
                            { Header: 'Tenure',             accessor: 'approved_tenure' ,width:100},
                            { Header: 'DPD Status',         accessor: 'dpd' ,width:100},
                            { Header: 'POS',                accessor: 'principal_outstanding' ,width:100},
                            { Header: 'Overdue Principal',  accessor: 'principle_due',width:130},      
                            { Header: 'Overdue Interest',   accessor: 'interest_due',width:130},
                            { Header: 'Penality',           accessor: 'charges_due' ,width:100},
                            { Header: 'Total Overdue Amt',  accessor: 'total_overdue' ,width:140}
                      ]} 
                  defaultSorted={[{id:'disbursal_date',desc:true}]} 
                  defaultPageSize={20}
                  className="-striped -highlight"
                  showPagination={false}
              />
              <div type="button" className="btn btn-primary btn-sm-5" style={{float:'left'}}  onClick={(e) => this.prevPage(e='POS_Report')}> Previous </div>
              <div type="button" className="btn btn-primary btn-sm-5" style={{float:'right'}} onClick={(e) => this.nxtpage(e='POS_Report')}> Next </div>
              
        </div>
{/*  =========================================================================== wise details tab =================================================================== */}
        <div ref='wise_detail' style={{display : 'none'}} >
            
        <div className="card">
              <div className="card-header">
                  <button type="button" className="btn btn-primary btn-sm" name = 'applicant_details' onClick={(e) => this.wiseTabs_func(e)} > Applicant Details </button>&nbsp;&nbsp;
                  <button type="button" className="btn btn-primary btn-sm" name = 'payment_history'   onClick={(e) => this.wiseTabs_func(e)} > Payment History   </button>&nbsp;&nbsp;
                  <button type="button" className="btn btn-primary btn-sm" name = 'details'           onClick={(e) => this.wiseTabs_func(e)} > Details           </button>&nbsp;&nbsp;
              </div>
        </div>
{/*  =========================================================================== Application Details Tab =================================================================== */}
            <div ref='applicant_details' style={{display : 'block'}}>
            
            <div className="card">
              <div className="card-header">
              Applicant Details
              </div>
              <div className="card-body">

              <table className="table">
                      <tr>
                        <th className="col-md-9" scope="row">Partners ID</th>
                        <td className="col-md-3" >{this.state.letsMd_id}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">StashFin Loan ID</th>
                        <td className="col-md-3" >{this.state.st_loan_id}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">Applicant Name</th>
                        <td className="col-md-3" >{this.state.customer_name}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">Approved Amount</th>
                        <td className="col-md-3" >{this.state.approved_amount}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">Close Date</th>
                        <td className="col-md-3" >{this.state.last_date}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">Tenure</th>
                        <td className="col-md-3" >{this.state.approved_tenure}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">Loan Rate</th>
                        <td className="col-md-3" >{this.state.approved_rate}%</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">Product Type</th>
                        <td className="col-md-3" >{this.state.product_code}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">Principal Outstanding</th>
                        <td className="col-md-3" >{this.state.app_principle_due}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">First Installment Date</th>
                        <td className="col-md-3" >{this.state.first_date}</td>
                      </tr>
                      <tr>
                        <th className="col-md-9" scope="row">Current Stage</th>
                        <td className="col-md-3" >{this.state.MaxDPD}</td>
                      </tr>
                      <tr> <td className="col-md-9" ></td><td className="col-md-3" ></td></tr>
                  </table>
                                                
              </div>
            </div>



            </div>
{/*  =========================================================================== Payment History Tab =================================================================== */}
            <div ref='payment_history' style={{display : 'none'}}>
                    <div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >ID</div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Paymnet</div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Paymnet Mode</div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Transaction Id</div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Payment Received Date</div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Extra Amount</div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Status</div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Remarks</div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Create Date</div>
                    </div>
                
                    <div>
                    {
                        this.state.paymentDetails ? this.state.paymentDetails.map((value) =>
                        <div>
                            <div className="col-lg-1" style={{color: 'blue'}} onClick={(e) => this.getPaymentChildTab(value.id)} data-toggle="modal" data-target=".bd-payment-modal-lg"> {value.id ? value.id : ''} </div>
                            <div className="col-lg-1"> {value.amt_payment     ? value.amt_payment     : '--'} </div>
                            <div className="col-lg-2"> {value.mode            ? value.mode            : '--'} </div>
                            <div className="col-lg-2"> {value.transaction_id  ? value.transaction_id  : '--'} </div>
                            <div className="col-lg-2"> {value.received_date   ? value.received_date   : '--'} </div>
                            <div className="col-lg-1"> {value.extra_amount    ? value.extra_amount    : '--'} </div>
                            <div className="col-lg-1"> {value.inst_status     ? value.inst_status     : '--'} </div>
                            <div className="col-lg-1">  </div>
                            <div className="col-lg-1"> {value.create_date     ? value.create_date     : '--'} </div>
                    </div>       
                        ): '--'
                    }                  
                  </div>

                  <div  className="modal  fade bd-payment-modal-lg"  tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" style={{minWidth:"1200px" ,marginTop:"205px"}}>
                      <div className="modal-content" style={{paddingTop : "6px",paddingRight : "6px",paddingLeft : "6px",paddingBottom : "6px",}} >
                        <div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Loan Id</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Installment No.</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Code Payment Type</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Amount</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Installment Date</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-3" >Payment Recived Date</div>
                        </div>
                            <div>
                              { 
                              this.state.instDetails ? this.state.instDetails.map((value) =>
                                  <div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.loan_id            ? value.loan_id            : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.inst_number        ? value.inst_number        : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.payment_code_type  ? value.payment_code_type  : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.amount_payment     ? value.amount_payment     : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.inst_date          ? value.inst_date          : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-3" >{ value.payment_date       ? value.payment_date       : '--' }</div>
                                  </div>
                                ) : '--'
                              }                  
                          </div>
                      </div>
                    </div>
                  </div>
            </div>
{/*  =========================================================================== Details Tab =================================================================== */}
            <div ref='details' style={{display : 'none'}}>
                    <div>
                      <div style={{background: '#2196f3' , color: 'white'}} ></div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Instt No    </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Instt.Amt   </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Instt.Date  </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Prin.Amt    </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Int.Amt     </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Dis         </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Recv.Prin   </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Recv.Int    </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Outsd.Prin  </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Outsd Int   </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Paying Date </div>
                      <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Inst.Stat   </div>
                    </div>
   
                    <div>
                      {
                          this.state.detailsPage  ?  this.state.detailsPage.map((value ,) =>
                          <div> 
                               <div className="col-lg-1"  style={{color: 'blue'}} data-toggle="modal" onClick={(e) => this.getinstColender(value.inst_number)} data-target=".bd-details-modal-lg3"> {value.inst_number ? value.inst_number : ''} </div>
                               <div className="col-lg-1"> {value.inst_amount                 ? value.inst_amount                   : '--'} </div>
                               <div className="col-lg-1"> {value.inst_date                   ? value.inst_date                     : '--'} </div>
                               <div className="col-lg-1"> {value.inst_principal              ? value.inst_principal                : '--'} </div>
                               <div className="col-lg-1"> {value.inst_interest               ? value.inst_interest                 : '--'} </div>
                               <div className="col-lg-1"> {value.inst_discount               ? value.inst_discount                 : '--'} </div>
                               <div className="col-lg-1"> {value.received_principal          ? value.received_principal            : '--'} </div>
                               <div className="col-lg-1"> {value.received_interest           ? value.received_interest             : '--'} </div>
                               <div className="col-lg-1"> {value.amount_outstanding_principal? value.amount_outstanding_principal  : '--'} </div>
                               <div className="col-lg-1"> {value.amount_outstanding_interest ? value.amount_outstanding_interest   : '--'} </div>
                               <div className="col-lg-1"> {value.last_paying_date            ? value.last_paying_date              : '--'} </div>
                               <div className="col-lg-1"> {value.emi_status                  ? value.emi_status                    : '--'} </div>                              
                        </div>       
                          ): '--'
                      }                  
                    </div>

                    <div  className="modal fade bd-details-modal-lg3" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                      <div className="modal-dialog modal-lg" style={{minWidth:"1200px" ,marginTop:"205px"}}>
                        <div className="modal-content" style={{paddingTop : "6px",paddingRight : "6px",paddingLeft : "6px",paddingBottom : "6px",}} >
                            <div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >COLENDER    </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >AMT         </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >PRIN.       </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >INT.        </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >RECV. PRIN  </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >RECV. INT   </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >OUTSD PRIN. </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >OUTSD INT.  </div>
                            </div>
                                    <div>
                                      { 
                                      this.state.instColender ? this.state.instColender.map((value) =>
                                          <div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.company_name                  ? value.company_name                  : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.inst_amount                   ? value.inst_amount                   : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.inst_principal                ? value.inst_principal                : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.inst_interest                 ? value.inst_interest                 : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.received_principal            ? value.received_principal            : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.received_interest             ? value.received_interest             : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.amount_outstanding_principal  ? value.amount_outstanding_principal  : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.amount_outstanding_interest   ? value.amount_outstanding_interest   : '--' }</div>                                        
                                          </div>
                                        ) : '--'
                                      }                  
                                  </div>
                        </div>

                      </div>
                    </div>
            </div>

            <div ref='akara_details'  >
                    
            <ReactTable data={this.state.AkaradetailsPage} columns={[
                            { Header: 'Insasfsdctt No', id:'inst_number', accessor: d => d.loan_id, Cell: row => (<span style={{color: 'blue'}} data-toggle="modal" onClick={(e) => this.getinstColender(row.value)}  data-target=".bd-details-modal-lg4">{row.value}</span>), },
                            // { Header: 'Inst Number             ',       accessor: 'inst_number' },
                            { Header: 'Instt.Amount            ',       accessor: 'inst_amt' },
                            { Header: 'Instt.Date              ',       accessor: 'int_amt',},
                            { Header: 'Prin.Amount             ',       accessor: 'pri_amt',},
                            { Header: 'Int.Amount              ',       accessor: 'int_amt',},
                            { Header: 'Akara Prin Due          ',       accessor: 'akara_prin_due',},
                            { Header: 'Akara Int Due           ',       accessor: 'akara_int_due',},
                            { Header: 'Akara Prin              ',       accessor: 'akara_prin',},
                            { Header: 'Akara Interest          ',       accessor: 'akara_interest',},
                            { Header: 'Akara Prin Received     ',       accessor: 'akara_prin_received',},
                            { Header: 'Akara Interest Received ',       accessor: 'akara_interest_received',},
                            { Header: 'Recv.Prin               ',       accessor: 'recive_p',},
                            { Header: 'Recv.Int                ',       accessor: 'rec_i',},
                            { Header: 'Outsd.Prin              ',       accessor: 'out_p',},
                            { Header: 'Outsd Int               ',       accessor: 'out_i' },
                            { Header: 'Partner Share           ',       accessor: 'partner_share' },
                            { Header: 'Partner Share Received  ',       accessor: 'partner_share_received' },
                            { Header: 'Inst.Stat               ',       accessor: 'emi_status' },

                        ]} 
                    // defaultSorted={[{id:'disbursal_date',desc:true}]} 
                    defaultPageSize={20}
                    showPagination={false} 
                    className="-striped -highlight"
              /> 
                    
               

                    <div  className="modal fade bd-details-modal-lg4" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                      <div className="modal-dialog modal-lg" style={{minWidth:"1200px" ,marginTop:"205px"}}>
                        <div className="modal-content" style={{paddingTop : "6px",paddingRight : "6px",paddingLeft : "6px",paddingBottom : "6px",}} >
                            <div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >COLENDER    </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >AMT         </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >PRIN.       </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >INT.        </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >RECV. PRIN  </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >RECV. INT   </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >OUTSD PRIN. </div>
                              <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >OUTSD INT.  </div>
                            </div>
                                    <div>
                                      { 
                                      this.state.instColender ? this.state.instColender.map((value) =>
                                          <div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.company_name                  ? value.company_name                  : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.inst_amount                   ? value.inst_amount                   : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.inst_principal                ? value.inst_principal                : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.inst_interest                 ? value.inst_interest                 : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.received_principal            ? value.received_principal            : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.received_interest             ? value.received_interest             : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.amount_outstanding_principal  ? value.amount_outstanding_principal  : '--' }</div>
                                              <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.amount_outstanding_interest   ? value.amount_outstanding_interest   : '--' }</div>                                        
                                          </div>
                                        ) : '--'
                                      }                  
                                  </div>
                        </div>

                      </div>
                    </div>
            </div>

        </div>

        

{/*  =========================================================================== Payment Receive Tab =================================================================== */}

            <div ref='payment_received' style={{display : 'none'}} >

            <div className="card">
              <div className="card-header">

                  From Date<input type="date" onChange={(event)=> this.recvSetStartDate(event)} />
                    &nbsp;&nbsp;
                  To Date<input type="date" onChange={(event)=> this.recvSetEndDate(event)} />
                    &nbsp;&nbsp;    
                <select name="lead_status" id="select" className="deepsearchselect" value={this.state.PaymentLeadStatus} onChange={(event)=> this.PaymentLeadStatus(event)}>
                  <option value="">Status</option>
                  <option value="clear">Clear</option>
                  <option value='bounce'>Bounce</option>
                  <option value="refund">Refund</option>
                </select>&nbsp;&nbsp;
                {/* <select name="lead_status" id="select"  className="deepsearchselect" value={this.state.LetsMD} onChange={(event)=> this.set_PRT_UTM_STATUS(event)}>
                  <option value="">UTM Source</option>
                  <option value="ALL">ALL</option>
                  <option value="LetsMD">LetsMD</option>
                  <option value="LoanSimple">LoanSImple</option>
                  <option value="Rupeelend">Rupeelend</option>
                </select>&nbsp;&nbsp; */}
                <div type="button" className="btn btn-primary btn-sm" name = 'payTab' onClick={(e) => this.getPaymentHisTab(e)} > Search</div>
                &nbsp;&nbsp;
                <div type="button" className="btn btn-primary btn-sm" onClick={(e) => this.getPaymentHisTab(e='export')}> Export</div>
                &nbsp;&nbsp;
              </div>
        </div>
        <h5>Payment Received</h5>

                <ReactTable data={this.state.paymentRecDetails} columns={[
                            { Header: 'Loan Id', id:'loan_id', accessor: d => d.loan_id, Cell: row => (<span style={{color: 'blue'}} data-toggle="modal" onClick={(e) => this.getPaymentChildTab(row.value)}  data-target=".bd-payment-modal-lg2">{row.value}</span>), },
                            { Header: 'Payment Date', accessor: 'payment_date' },
                            { Header: 'Mode', accessor: 'mode' },
                            { Header: 'Payment Amount', accessor:'PaymentAmount',}, 
                            { Header: 'Principal Paid', accessor: 'PrincipalPaid' }, 
                            { Header: 'Interest Paid', accessor: 'InterestPaid' },
                            { Header: 'Late Fees Paid', accessor: 'LateFeesPaid' },
                            { Header: 'Penalty Paid', accessor: 'PenaltyPaid' },
                        ]} 
                    defaultSorted={[{id:'disbursal_date',desc:true}]} 
                    defaultPageSize={20}
                    showPagination={false} 
                    className="-striped -highlight"
              /> 
              <div type="button" className="btn btn-primary btn-sm-5" style={{float:'left'}}  onClick={(e) => this.prevPage(e='Payment_Received')}> Previous </div>
              <div type="button" className="btn btn-primary btn-sm-5" style={{float:'right'}} onClick={(e) => this.nxtpage(e='Payment_Received')}> Next </div>

                  <div  className="modal fade bd-payment-modal-lg2"  tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" style={{minWidth:"1200px" ,marginTop:"205px"}}>
                      <div className="modal-content" style={{paddingTop : "6px",paddingRight : "6px",paddingLeft : "6px",paddingBottom : "6px",}} >
                        <div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-1" >Loan Id</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Installment No.</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Code Payment Type</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Amount</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-2" >Installment Date</div>
                        <div style={{background: '#2196f3' , color: 'white'}} className="col-sm-3" >Payment Recived Date</div>
                        </div>
                            <div>
                              { 
                              this.state.instDetails ? this.state.instDetails.map((value) =>
                                  <div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-1" >{ value.loan_id            ? value.loan_id            : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.inst_number        ? value.inst_number        : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.payment_code_type  ? value.payment_code_type  : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.amount_payment     ? value.amount_payment     : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-2" >{ value.inst_date          ? value.inst_date          : '--' }</div>
                                      <div style={{background: '#DCDCDC' , color: 'black'}} className="col-sm-3" >{ value.payment_date       ? value.payment_date       : '--' }</div>
                                  </div>
                                ) : '--'
                              }                  
                          </div>
                      </div>
                    </div>
                  </div>
              </div>        
       
{/*  =========================================================================== END =================================================================== */}

        </CardHeader>
      </Card> 

 


  </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/partnerDashboard.js